import * as React from "react";
import { cn } from "@/lib/utils";
import { AspectRatio } from "@/services/bedrock/dtos/DesignPackage";
import { ASPECT_CLASS } from "./PackageCard";

const ASPECT_VALUE: Record<AspectRatio, number> = {
  square_1_1: 1,
  portrait_4_5: 4 / 5,
  portrait_9_16: 9 / 16,
};

interface FitFrameProps {
  aspectRatio: AspectRatio;
  /** Classes for the frame itself, such as a max width. */
  className?: string;
  children: React.ReactNode;
}

/**
 * A frame at the slide's aspect ratio. On wide screens it takes the rest of its flex column and grows
 * as large as fits both ways, so nothing is cropped whichever side runs out first; below that it
 * follows the width.
 */
export const FitFrame: React.FC<FitFrameProps> = ({ aspectRatio, className, children }) => (
  <div className="flex w-full items-center justify-center lg:min-h-0 lg:flex-1 lg:[container-type:size]">
    <div
      className={cn("w-full lg:w-[min(100cqw,calc(100cqh*var(--fit-ratio)))]", ASPECT_CLASS[aspectRatio], className)}
      style={{ "--fit-ratio": ASPECT_VALUE[aspectRatio] } as React.CSSProperties}
    >
      {children}
    </div>
  </div>
);
